import { observe } from "mobx";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { AggregatedEventGeneralDataParser } from "./AggregatedEventGeneralDataParser/AggregatedEventGeneralDataParser";
import { AggregatedGameDataParser } from "./AggregatedGameDataParser/AggregatedGameDataParser";
import { AggregatedScoresDataParser } from "./AggregatedScoresDataParser/AggregatedScoresDataParser";
export class AggregatedEventsParser {
    constructor(retriever, timeFormat) {
        this.retriever = retriever;
        this.aggregatedEvents = [];
        this.events = [];
        this.currentSelectedTimeZone = 0;
        this.disposeTimeZone = () => { };
        this.disposeAggregatedEvents = () => { };
        this.disposeEvents = () => { };
        this.messageBus = retriever.messageBus;
        this.sendAggregatedGamesData = this.sendAggregatedGamesData.bind(this);
        this.sendAggregatedGeneralInfoData = this.sendAggregatedGeneralInfoData.bind(this);
        this.sendAggregatedScoresData = this.sendAggregatedScoresData.bind(this);
        this.timeFormat = timeFormat;
    }
    activate() {
        this.disposeTimeZone = observe(this.retriever, "currentSelectedTimeZone", (change) => {
            this.updateTimeZone(change.newValue);
        });
        this.disposeAggregatedEvents = observe(this.retriever, "aggregatedEvents", (change) => {
            this.updateAggregatedEvents(change.newValue);
        });
        this.disposeEvents = observe(this.retriever, "events", (change) => {
            this.updateEvents(change.newValue);
        });
        this.retriever.activate();
        this.messageBus.on(InternalMessageBusChannels.aggregatedEvents.games.request, this.sendAggregatedGamesData);
        this.messageBus.on(InternalMessageBusChannels.aggregatedEvents.scores.request, this.sendAggregatedScoresData);
    }
    deactivate() {
        this.disposeTimeZone();
        this.disposeAggregatedEvents();
        this.disposeEvents();
        this.retriever.deactivate();
        this.messageBus.off(InternalMessageBusChannels.aggregatedEvents.games.request, this.sendAggregatedGamesData);
        this.messageBus.off(InternalMessageBusChannels.aggregatedEvents.scores.request, this.sendAggregatedScoresData);
    }
    updateTimeZone(changedTimeZone) {
        this.currentSelectedTimeZone = changedTimeZone;
        this.aggregatedEvents.length > 0 &&
            this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.generalInfo.update, { generalInfo: AggregatedEventGeneralDataParser.parse(this.aggregatedEvents[0], this.currentSelectedTimeZone, this.timeFormat) });
    }
    updateAggregatedEvents(aggregatedEvents) {
        this.aggregatedEvents = aggregatedEvents;
        this.sendAggregatedGeneralInfoData();
        this.sendAggregatedScoresData();
        this.sendAggregatedGamesData();
    }
    updateEvents(events) {
        this.events = events;
        this.sendAggregatedGamesData();
    }
    sendAggregatedScoresData() {
        this.aggregatedEvents[0] && this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.scores.update, { scores: AggregatedScoresDataParser.parse(this.aggregatedEvents[0]) });
    }
    sendAggregatedGamesData() {
        this.aggregatedEvents[0] && this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.games.update, { games: AggregatedGameDataParser.parse(this.aggregatedEvents[0], this.events) });
    }
    sendAggregatedGeneralInfoData() {
        this.aggregatedEvents[0] && this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.generalInfo.update, { generalInfo: AggregatedEventGeneralDataParser.parse(this.aggregatedEvents[0], this.currentSelectedTimeZone, this.timeFormat) });
    }
}
//# sourceMappingURL=AggregatedEventsParser.js.map